import type { PiralPlugin } from 'piral-core'
import type { AuthenticationApi, User } from './types'
import userProfile from './userProfile'

const getSafeUser = () => {
  const user = userProfile.value
  if (!user) {
    throw new Error('No user available.')
  }
  return user
}

export function createWrwksAuthenticationApi(): PiralPlugin<AuthenticationApi<Role>> {
  return () => ({
    isAuthenticated(): boolean {
      return userProfile.value !== null
    },
    getUser(): User<Role> {
      return getSafeUser()
    },
    getUserId(): string {
      return getSafeUser().id
    },
    getRoles(): Role[] {
      return getSafeUser().roles
    },
    hasRole(role: Role): boolean {
      return getSafeUser().roles.includes(role)
    },
    hasAnyRole(roles: Role[]): boolean {
      return roles.some((role) => getSafeUser().roles.includes(role))
    }
  })
}
